// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangePasswordForm-errorMessage-qTZOZ {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/*************************Sidenavigation Styles start******************************************/

.ChangePasswordForm-listContainer-Z5y1k {
	padding-left: 0px;
	list-style-type: none;
}

.ChangePasswordForm-sideNavitem-oi0ub {
	display: block;
	padding: 6px 0;
	font-size: 16px;
	color: var(--modalText-color);
	text-decoration: none;
}

.ChangePasswordForm-sideNavitem-oi0ub:hover {
	text-decoration: none;
	color: var(--common-text-color);
}

.ChangePasswordForm-sideNavitem-oi0ub:active {
	text-decoration: none;
	color: var(--common-text-color);
	font-weight: bold;
}

.ChangePasswordForm-sideNavitem-oi0ub:active {
	text-decoration: none;
	color: var(--common-text-color);
	font-weight: bold;
}

/*************************Sidenavigation Styles end******************************************/

.ChangePasswordForm-panelHeader-VG3uH {
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.ChangePasswordForm-spaceTop2-HlOTA {
	margin-top: 12px;
}

.ChangePasswordForm-space4-cG5bB {
	margin-bottom: 24px;
}

.ChangePasswordForm-button-wPKCq {
	border-color: var(--btn-primary-bg-hover);
	background-color: var(--btn-primary-bg-hover);
	color: var(--white-text);
	font-size: 18px;
	padding: 9px 27px;
	width: 100%;
	font-weight: 500;
}

.ChangePasswordForm-button-wPKCq:hover {
	background: rgba(54, 50, 119, 0.8);
}

.ChangePasswordForm-button-wPKCq:focus {
	border-color: #0074c2;
	-webkit-box-shadow: 0 0 8px rgba(0, 116, 194, 0.6);
	        box-shadow: 0 0 8px rgba(0, 116, 194, 0.6);
}

.ChangePasswordForm-btnPrimary-PaFHB {
	border-color: var(--btn-primary-bg);
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
}

.ChangePasswordForm-btnPrimary-PaFHB:hover,
.ChangePasswordForm-btnPrimary-PaFHB:focus,
.ChangePasswordForm-btnPrimary-PaFHB:active,
.ChangePasswordForm-btnPrimary-PaFHB:active:hover,
.ChangePasswordForm-btnPrimary-PaFHB:active:focus {
	border-color: var(--btn-primary-bg-hover);
	background-color: var(--btn-primary-bg-hover);
	color: var(--white-text);
}

.ChangePasswordForm-btnPrimaryBorder-soqSy {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
}

.ChangePasswordForm-btnPrimaryBorder-soqSy:hover,
.ChangePasswordForm-btnPrimaryBorder-soqSy:focus,
.ChangePasswordForm-btnPrimaryBorder-soqSy:active,
.ChangePasswordForm-btnPrimaryBorder-soqSy:active:hover,
.ChangePasswordForm-btnPrimaryBorder-soqSy:active:focus {
	border-color: var(--btn-primary-bg-hover);
	color: var(--btn-primary-bg-hover);
	background-color: var(--primary-white-bg);
}

.ChangePasswordForm-labelText-eeEnQ {
	font-size: 14px;
	color: var(--common-text-color);
	font-weight: normal;
	margin-bottom: 12px;
}

.ChangePasswordForm-formGroup-TQAvd {
	margin-bottom: 6px;
}

.ChangePasswordForm-space2-gTXj1 {
	margin-bottom: 12px;
}

.ChangePasswordForm-btnRight-GxwMf {
	float: right;
}

.ChangePasswordForm-textRight-vgac6 {
	text-align: right;
}

.ChangePasswordForm-formGroup-TQAvd {
	margin-bottom: 6px;
}

.ChangePasswordForm-labelText-eeEnQ {
	font-size: 14px;
	color: var(--common-text-color);
	font-weight: normal;
}

.ChangePasswordForm-headingCss-dw9uw {
	background: var(--common-gray-bg-color);
	margin: 0;
	font-size: 20px;
	font-weight: 600;
	padding: 22px 23px;
	border-radius: 12px 12px 0 0;
}

.ChangePasswordForm-paddingAll-RuUr_ {
	padding: 20px 24px;
}

.ChangePasswordForm-fullWidth-oU1AH {
	width: 100%;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

@media screen and (max-width: 743px) {
	.ChangePasswordForm-textRight-vgac6 {
		text-align: left;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/ForgotPassword/ChangePasswordForm/ChangePasswordForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACNA,+FAA+F;;AAE/F;CACC,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,+BAA+B;AAChC;;AAEA;CACC,qBAAqB;CACrB,+BAA+B;CAC/B,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,+BAA+B;CAC/B,iBAAiB;AAClB;;AAEA,6FAA6F;;AAE7F;CACC,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yCAAyC;CACzC,6CAA6C;CAC7C,wBAAwB;CACxB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,qBAAqB;CACrB,kDAA0C;SAA1C,0CAA0C;AAC3C;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;CACvC,wBAAwB;AACzB;;AAGA;;;;;CAKC,yCAAyC;CACzC,6CAA6C;CAC7C,wBAAwB;AACzB;;AAEA;CACC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;AAC1C;;AAEA;;;;;CAKC,yCAAyC;CACzC,kCAAkC;CAClC,yCAAyC;AAC1C;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,mBAAmB;AACpB;;AAEA;CACC,uCAAuC;CACvC,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../../utils.css';\n\n/*************************Sidenavigation Styles start******************************************/\n\n.listContainer {\n\tpadding-left: 0px;\n\tlist-style-type: none;\n}\n\n.sideNavitem {\n\tdisplay: block;\n\tpadding: 6px 0;\n\tfont-size: 16px;\n\tcolor: var(--modalText-color);\n\ttext-decoration: none;\n}\n\n.sideNavitem:hover {\n\ttext-decoration: none;\n\tcolor: var(--common-text-color);\n}\n\n.sideNavitem:active {\n\ttext-decoration: none;\n\tcolor: var(--common-text-color);\n\tfont-weight: bold;\n}\n\n.sideNavitem:active {\n\ttext-decoration: none;\n\tcolor: var(--common-text-color);\n\tfont-weight: bold;\n}\n\n/*************************Sidenavigation Styles end******************************************/\n\n.panelHeader {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.button {\n\tborder-color: var(--btn-primary-bg-hover);\n\tbackground-color: var(--btn-primary-bg-hover);\n\tcolor: var(--white-text);\n\tfont-size: 18px;\n\tpadding: 9px 27px;\n\twidth: 100%;\n\tfont-weight: 500;\n}\n\n.button:hover {\n\tbackground: rgba(54, 50, 119, 0.8);\n}\n\n.button:focus {\n\tborder-color: #0074c2;\n\tbox-shadow: 0 0 8px rgba(0, 116, 194, 0.6);\n}\n\n.btnPrimary {\n\tborder-color: var(--btn-primary-bg);\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n\tborder-color: var(--btn-primary-bg-hover);\n\tbackground-color: var(--btn-primary-bg-hover);\n\tcolor: var(--white-text);\n}\n\n.btnPrimaryBorder {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n\tborder-color: var(--btn-primary-bg-hover);\n\tcolor: var(--btn-primary-bg-hover);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.labelText {\n\tfont-size: 14px;\n\tcolor: var(--common-text-color);\n\tfont-weight: normal;\n\tmargin-bottom: 12px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.btnRight {\n\tfloat: right;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.labelText {\n\tfont-size: 14px;\n\tcolor: var(--common-text-color);\n\tfont-weight: normal;\n}\n\n.headingCss {\n\tbackground: var(--common-gray-bg-color);\n\tmargin: 0;\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tpadding: 22px 23px;\n\tborder-radius: 12px 12px 0 0;\n}\n\n.paddingAll {\n\tpadding: 20px 24px;\n}\n\n.fullWidth {\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n@media screen and (max-width: 743px) {\n\t.textRight {\n\t\ttext-align: left;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ChangePasswordForm-errorMessage-qTZOZ`,
	"listContainer": `ChangePasswordForm-listContainer-Z5y1k`,
	"sideNavitem": `ChangePasswordForm-sideNavitem-oi0ub`,
	"panelHeader": `ChangePasswordForm-panelHeader-VG3uH`,
	"spaceTop2": `ChangePasswordForm-spaceTop2-HlOTA`,
	"space4": `ChangePasswordForm-space4-cG5bB`,
	"button": `ChangePasswordForm-button-wPKCq`,
	"btnPrimary": `ChangePasswordForm-btnPrimary-PaFHB`,
	"btnPrimaryBorder": `ChangePasswordForm-btnPrimaryBorder-soqSy`,
	"labelText": `ChangePasswordForm-labelText-eeEnQ`,
	"formGroup": `ChangePasswordForm-formGroup-TQAvd`,
	"space2": `ChangePasswordForm-space2-gTXj1`,
	"btnRight": `ChangePasswordForm-btnRight-GxwMf`,
	"textRight": `ChangePasswordForm-textRight-vgac6`,
	"headingCss": `ChangePasswordForm-headingCss-dw9uw`,
	"paddingAll": `ChangePasswordForm-paddingAll-RuUr_`,
	"fullWidth": `ChangePasswordForm-fullWidth-oU1AH`
};
module.exports = ___CSS_LOADER_EXPORT___;
